import { Link } from 'react-router-dom';
import { useWallet } from '@/lib/walletHooks';
import { formatCurrencyEurRo } from '@/lib/format';
import { Pill } from '@/components/ui/Pill';
import { canSeeBilling } from '@/lib/permissions';
import { useMe } from '@/lib/useMe';

export function SoldCredite() {
  const { data: me } = useMe();
  const { data: w, isPending, isError } = useWallet();
  if (!canSeeBilling(me)) return null;
  if (isPending) return <div className="h-36 animate-pulse rounded-2xl bg-wash" aria-hidden />;
  if (isError || !w) {
    return (
      <section>
        <p className="text-[11.5px] font-medium uppercase tracking-[0.06em] text-ink-3">Sold credite</p>
        <p className="mt-2 text-[13.5px] text-bad">Nu s-a putut încărca soldul.</p>
      </section>
    );
  }
  // Guard the divide: monthlyEur is a fixed pilot 500 today, but 0 would make the
  // ratio NaN and emit `width: NaN%` (an invisible-but-broken bar).
  const pct = w.monthlyEur > 0
    ? Math.max(0, Math.min(100, Math.round((w.balanceEur / w.monthlyEur) * 100)))
    : 0;
  return (
    <section>
      <div className="flex items-center justify-between gap-3">
        <p className="text-[11.5px] font-medium uppercase tracking-[0.06em] text-ink-3">Sold credite</p>
        {w.lowBalance && <Pill variant="warn">Sold redus</Pill>}
      </div>
      <p className={`mt-1 text-[40px] font-[650] leading-none tabular-nums ${w.lowBalance ? 'text-warn' : 'text-ink'}`}>
        {formatCurrencyEurRo(w.balanceEur)}
      </p>
      <div className="mt-3 h-1.5 w-full max-w-xs overflow-hidden rounded-full bg-rule-soft">
        <div className={`h-full ${w.lowBalance ? 'bg-warn' : 'bg-teal'}`} style={{ width: `${pct}%` }} />
      </div>
      <p className="mt-2 text-[13.5px] text-ink-3">
        {formatCurrencyEurRo(w.balanceEur)} din {formatCurrencyEurRo(w.monthlyEur)} · se reînnoiește pe data de {w.resetDay}
        {' · '}<Link to="/utilizare" className="text-teal hover:underline">Utilizare</Link>
      </p>
    </section>
  );
}
